import api from 'api';

import { defaultPagination } from './general';

type GetVehicleAccessoriesType = {id: number | string}

export const listVehicleAccessories = async (params) => api().get('/vehicle_accessories', { params: { ...defaultPagination, ...params } });

export const getVehicleAccessories = async ({ id }:GetVehicleAccessoriesType) => api().get(`/vehicle_accessories/show/${id}`);

export const createVehicleAccessories = async ({ data, parentId }) => api().post(`/vehicle_accessories/${parentId}`, data);

export const updateVehicleAccessories = async ({ id, data }) => api().put(`/vehicle_accessories/${id}`, data);
